module.exports = __webpack_public_path__ + "img/ProcurementPlatform.fd714aba.png";